// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Content from '@/components/Content'
import Default from '@/components/Default'
import LayoutFichaCliente from '@/components/LayoutFichaCliente'
import VCalendar from 'v-calendar'
import VueCurrencyInput from 'vue-currency-input'
import VueCurrencyFilter from 'vue-currency-filter'
import moment from 'moment'

import '@/assets/css/material-components-web.min.css'
import '@/assets/css/icon.css'
import '@/assets/css/content-layout/css/font-nunito.css'
import '@/assets/css/fonts.css'
import '@/assets/css/bootstrap.min.css'
import '@/assets/css/content-layout/css/style.css'
import '@/assets/css/content-layout/css/normalize.css'
import '@/assets/css/content-layout/css/tabs.css'
import '@/assets/css/content-layout/css/tabstyles.css'
import '@/assets/css/content-layout/css/cool-select.css'
// import '@/assets/css/content-layout/js/modernizr.custom.js'
import '@/assets/css/content-layout/js/cbpFWTabs.js'
import '@/assets/css/content-layout/js/cbpFWTabs2.js'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { CoolSelectPlugin } from 'vue-cool-select'
import SmartTable from 'vuejs-smart-table'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(CoolSelectPlugin)
Vue.use(SmartTable)
Vue.config.productionTip = false
Vue.component('Default-layout', Default)
Vue.component('Content-layout', Content)
Vue.component('LayoutFichaCliente-layout', LayoutFichaCliente)
Vue.use(SmartTable)
Vue.use(VCalendar, { componentPrefix: 'vc' })

/* formateador de fecha Cristian Ubilla */
Vue.filter(
	'DD-MM-YYYY',
	// eslint-disable-next-line consistent-return
	(value) => {
	  if (value) {
			return moment(String(value)).format('DD-MM-YYYY')
	  }
	}
)
Vue.filter(
	'YYYYMMDD',
	// eslint-disable-next-line consistent-return
	(value) => {
	  if (value) {
			return moment(String(value)).format('YYYYMMDD')
	  }
	}
)
Vue.filter(
	'YYYY-MM-DD',
	// eslint-disable-next-line consistent-return
	(value) => {
	  if (value) {
			return moment(String(value)).format('YYYYMMDD')
	  }
	}
)
Vue.use(VueCurrencyInput)
Vue.use(VueCurrencyFilter, [{
	name: 'clp',
	symbol: '$',
	thousandsSeparator: '.',
	fractionCount: 0,
	fractionSeparator: ',',
	symbolPosition: 'front',
	symbolSpacing: true
},
{
	name: 'sol',
	symbol: 'S/.',
	thousandsSeparator: ',',
	fractionCount: 2,
	fractionSeparator: '.',
	symbolPosition: 'front',
	symbolSpacing: true
}])

var vm = new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')

window.vm = vm
window.$ = window.jQuery = require('jquery')
Vue.mixin({
	methods: {
	  formatoNumero: function (valor, canDecimal, miles, decimal) {
			if (valor === null || !isFinite(valor)) {
				// throw new TypeError('El valor no es valido')
				return 0
			}
			if (canDecimal === null || !isFinite(canDecimal)) {
				var len = valor.toString().split('.').length
				canDecimal = len > 1 ? len : 0
			}
			if (!decimal) {
				decimal = ','
			}
			if (!miles) {
				miles = '.'
			}
			valor = parseFloat(valor).toFixed(canDecimal)
			valor = valor.replace('.', decimal)
			var splitNum = valor.split(decimal)
			splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles)
			valor = splitNum.join(decimal)
			return valor
		},
		getIconoEstadoDocumento: function (estado) {
			var ico = ''
			// Credito
			if (estado === 'VI') {
				ico = require('@/assets/images/ico-vi.png')
			} else if (estado === 'CO') {
				ico = require('@/assets/images/ico-co.png')
			} else if (estado === 'PA') {
				ico = require('@/assets/images/ico-pa.png')
			} else if (estado === 'AN') {
				ico = require('@/assets/images/ico-an.png')
			} else if (estado === 'JU') {
				ico = require('@/assets/images/ico-ju.png')
			} else if (estado === 'PO') {
				ico = require('@/assets/images/ico-po.png')
			} else if (estado === 'VE') {
				ico = require('@/assets/images/ico-ve.png')
			// Factoring
			} else if (estado === 'MO') {
				ico = require('@/assets/images/ico-mo.png')
			} else if (estado === 'CA') {
				ico = require('@/assets/images/ico-ca.png')
			} else if (estado === 'RE') {
				ico = require('@/assets/images/ico-re.png')
			} else if (estado === 'EX') {
				ico = require('@/assets/images/ico-ex.png')
			} else if (estado === 'PR') {
				ico = require('@/assets/images/ico-pr.png')
			} else if (estado === 'PT') {
				ico = require('@/assets/images/ico-pt.png')
			} else if (estado === 'HI') {
				ico = require('@/assets/images/ico-hi.png')
			} else if (estado === 'CJ') {
				ico = require('@/assets/images/ico-cj.png')
			} else if (estado === 'CC') {
				ico = require('@/assets/images/ico-cc.png')
			} else if (estado === 'DE') {
				ico = require('@/assets/images/ico-de.png')
			}
			return ico
		},
		redirectFichaGestion: function (index) {
			var params = btoa(index)
			var href = '/FichaGestion?val=' + params
			if (location.pathname === '/FichaCliente') { window.location.href = href } else { window.open(href, '_blank') }
		},
		getTipoLinea: function (idLinea, listLineas) {
			var tipoLinea = null
			listLineas.forEach((value, key) => {
				if (parseInt(value.id_linea) === parseInt(idLinea)) {
					tipoLinea = parseInt(value.tipoLinea)
				}
			})
			return tipoLinea
		},
		descargaExcelGenerico: function (result) {
			const a = document.createElement('A')
			a.href = result.archivo
			a.setAttribute('download', `${result.nombre}.xlsx`)
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		},
		descargaPdfGenerico: function (result) {
			const a = document.createElement('A')
			a.href = result.file
			a.setAttribute('download', `${result.name}.pdf`)
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		},
		scrollFix: function (hash) {
			setTimeout(
				() =>
					window.$('html, body').animate(
						{
							scrollTop: window.$(hash).offset().top - 100
						},
						1000
					), 1
			)
		},
		habilitarBtnSubir (hash, decrease = 0) {
			window.$(window).scroll(function () {
				// if (window.$(this).scrollTop() > 50) {
				if (typeof window.$(hash).offset() !== 'undefined') {
					var scrollElement = window.$(hash).offset().top - decrease
					if (window.$(this).scrollTop() >= scrollElement) {
						window.$('.botonF1').show()
					} else if (window.$('.botonF1').is(':visible')) {
						window.$('.botonF1').fadeOut()
					}
				}
			})
		},
		validaPermiso (idPermiso) {
			let ret = false
			this.accessPermisos.forEach((value1, key1) => {
				if (parseInt(value1.id_permiso) === idPermiso) {
					ret = true
				}
			})
			return ret
		},
		showModall (idModal, flag) {
			if (flag) {
				window.$('#' + idModal).fadeIn()
			} else {
				window.$('#' + idModal).fadeOut()
			}
		},
		removeElementMultiselect (element, ref) {
			this.$refs[ref].removeElement(element)
		},
		getDv (rut) {
			var suma = 0
			var arrRut = rut.split('-')
			var rutSolo = arrRut[0]
			var continuar = true
			for (var i = 2; continuar; i++) {
				suma += (rutSolo % 10) * i
				rutSolo = parseInt((rutSolo / 10))
				i = (i === 7) ? 1 : i
				if (rutSolo === 0) { continuar = false } else { continuar = true }
			}
			var resto = parseInt(suma % 11)
			var dv = 11 - resto
			dv = (dv === 10) ? 'K' : dv
			dv = (dv === 11) ? '0' : dv
			return dv
		},
		quitaDecimal (value) {
			return (value) ? parseInt(value.match(/^\d+\.?\d{0,2}/)) : 0
		},
		admiteDecimal (input) {
			let value = input
			if (/^[ a-záéíóúüñ,.]*$/i.test(value)) {
				value = 0
			}
			value = value ? value.match(/^\d+\.?\d{0,2}/) : 0
			if (value !== 0) {
				value = value[0]
				if (value.length > 0 && value[0] === '0' && value[0] !== '0.') {
					value = value.substring(1, value.length)
				}
				/* var lastChar = value[value.length - 1]
				if (lastChar !== '.') {
					value = parseFloat(value)
				} */
			}
			return value
		},
		isNumeric: function (n) {
			let x = parseFloat(n)
			return !isNaN(x) && isFinite(x)
		},
		getDate (value, ret) {
			let x = ''
			if (value) {
				var datetime = value.split(' ')
				if (datetime.length === 2) {
					let date = datetime[0].split('-')
					let time = datetime[1]
					if (ret === 'day') {
						x = date[2]
					} else if (ret === 'month') {
						let m = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
						x = parseInt(date[1]) - 1
						x = m[x]
					} else if (ret === 'year') {
						x = date[0]
					} else if (ret === 'time') {
						x = time.substring(0, 8)
					}
				}
			}
			return x
		},
		ocultarMenuBolsa (tipoLinea) {
			if (tipoLinea === 1) {
				window.$('a[title=Bolsa]').hide()
			} else {
				window.$('a[title=Bolsa]').show()
			}
		}
	}
})



// WEBPACK FOOTER //
// ./src/main.js